import React from 'react';
import { projectPhotos } from '../data/renovationData';

export default function ProjectPhoto({ src, alt, sizes = '(max-width: 600px) 100vw, (max-width: 1000px) 50vw, 33vw', ...props }) {
  const photo = projectPhotos.find(item => item.image === src);
  return <img src={src} alt={alt ?? photo?.alt ?? 'Renovation by Maricopa Renovations'} width={photo?.width} height={photo?.height}
    srcSet={photo ? `${src.replace('.webp', '-640.webp')} 640w, ${src} ${photo.width}w` : undefined}
    sizes={photo ? sizes : undefined} decoding="async" {...props} />;
}
